import { composeWithDevTools } from '@redux-devtools/extension';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { JwtProvider } from 'contexts/JwtContext';
import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import reportWebVitals from 'reportWebVitals';

import { configAxios } from 'axiosConfig';
import LoadingAnimation from 'components/desktop/_general/Loading/LoadingAnimation';
import App from 'containers/App';
import ErrorBoundary from 'containers/ErrorBoundary';
import 'css/Main.scss';
import 'functions/arrayExtensions';
import { fireAlert } from 'functions/fireAlert';
import 'functions/promiseExtensions';
import { rootReducer } from 'reducers/rootReducer';

import i18n, { initI18n } from './i18n';

const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 10 });
const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

configAxios();

const container = document.getElementById('root');
const root = createRoot(container!);

window.addEventListener('unhandledrejection', (event) => {
	console.error('Unhandled promise rejection:', event.reason);
	fireAlert(2, i18n.t('_general:ERROR_GENERAL'), i18n.t('_general:ERROR_MESSAGE'), 10000);
});

// For other global errors
window.addEventListener('error', (event) => {
	console.error('Global error caught:', event.error);
	fireAlert(2, i18n.t('_general:ERROR_GENERAL'), i18n.t('_general:ERROR_MESSAGE'), 10000);
});

reportWebVitals();

initI18n().then(() => {
	root.render(
		<Suspense fallback={<LoadingAnimation isLoading={true} />}>
			<Provider store={store}>
				<ErrorBoundary>
					<JwtProvider>
						<App />
					</JwtProvider>
				</ErrorBoundary>
			</Provider>
		</Suspense>
	);
});
